import axios from 'axios';

const API_URL = '/medl/hent_produkt.php';

const cleanProductData = products => {
    return products.map(product => {
        const {
            aktiv,
            beskrivelse,
            bildeUrl,
            kategoriId,
            kategoriNavn,
            // eslint-disable-next-line camelcase
            kort_beskrivelse,
            mvaFritak,
            navn,
            pris,
            prodnr,
            produktInfo,
            produktUrl,
            // eslint-disable-next-line camelcase
            promo_tekst,
            promo,
            skatteFradrag,
            sort,
            temaer,
            tittel,
            ...rest
        } = product;

        let catName;
        if (kategoriNavn === 'Takkeprodukter') {
            catName = 'Produkter';
        } else {
            catName = kategoriNavn;
        }

        return {
            active: aktiv === 1,
            catId: kategoriId,
            catName: catName,
            descShort: kort_beskrivelse,
            description: beskrivelse,
            id: prodnr,
            imageUrl: bildeUrl,
            infoList: produktInfo,
            name: navn,
            price: parseInt(pris),
            featured: promo === '1',
            featuredText: promo_tekst,
            slug: produktUrl,
            sort: parseInt(sort),
            taxDeduction: skatteFradrag === 1,
            taxExempt: mvaFritak === 1,
            themes: temaer,
            title: tittel,
            ...rest
        };
    });
};

export const fetchProducts = async (ids = [], catIds = []) => {
    ids = Array.isArray(ids) ? ids : [parseInt(ids)];
    catIds = Array.isArray(catIds) ? catIds : [parseInt(catIds)];

    try {
        const response = await axios.post(API_URL, {
            prodnr: [...ids] || [],
            katid: [...catIds] || []
        });

        if (!response.data.data.produkter) {
            return null;
        }

        const cleanedData = cleanProductData(response.data.data.produkter);
        return cleanedData;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Failed to fetch product details:`, error);
    }
};
